<cb-dialog>
    <form class="flex-col flex" #activityForm="ngForm">
        <span class="mat-headline-6">{{ getTitle() }}</span>
        <cb-input
            label="Activity Duration (Days)"
            name="duration"
            [required]="true"
            [(ngModel)]="data.activity.activityDurationDays"
        ></cb-input>
        <cb-checkbox
            label="Default to Block Level"
            name="isControlledByParentLot"
            class="cb-margin-top-2x"
            [(ngModel)]="data.activity.isControlledByParentLot"
        ></cb-checkbox>
        <cb-checkbox
            label="Is Horizontal Predecessor"
            name="isActive"
            class="cb-margin-top-2x"
            [(ngModel)]="data.activity.isHorizontalPredecessor"
        ></cb-checkbox>
        @if (data.activity.isHorizontalPredecessor) {
            <mat-radio-group
                class="flex-col flex"
                [(ngModel)]="data.activity.horizontalPredecessorDateCalcType"
                [ngModelOptions]="{ standalone: true }"
            >
                @for (dateType of dateCalculationTypes; track dateType) {
                    <mat-radio-button class="mat-accent" [value]="dateType.id">
                        {{ dateType.label }}
                    </mat-radio-button>
                }
            </mat-radio-group>
        }
        <span class="mat-headline-6 cb-margin-top-2x">Predecessor Activities</span>
        <p>
            Activity Start Date will be set by the earliest matching Activity with "Set Start Date"
            set
        </p>
        <cb-table
            [loaded]="true"
            [stringColumns]="activityColumns"
            class="cb-margin-top-2x cb-margin-bottom-2x"
        >
            <tbody
                cbTableBody
                cdkDropList
                [cdkDropListData]="data.activity.relationships"
                (cdkDropListDropped)="dropPredecessor($event)"
            >
                @for (predecessor of data.activity.relationships; track predecessor) {
                    <tr cbTableRow cdkDrag cdkDragPreviewClass="cb-table-drag-preview">
                        <cb-td-text [value]="predecessor.predecessorName"></cb-td-text>
                        <cb-td-enum
                            [value]="predecessor.dateCalcType"
                            [enum]="DATE_CALC_TYPE_ENUM"
                        ></cb-td-enum>
                        <cb-td-icon
                            [value]="
                                predecessor.shouldSetStartBasedOnPredecessor
                                    ? 'check_box'
                                    : 'check_box_outline_blank'
                            "
                        ></cb-td-icon>
                        <cb-td-text [value]="predecessor.lagDays"></cb-td-text>
                        <td cbTableStickyCol="end" cbTableShrinkCol>
                            <button
                                mat-icon-button
                                class="cb-margin-right-2x"
                                (click)="openPredecessorDialog(predecessor)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button (click)="predecessorRemoveClicked(predecessor)">
                                <mat-icon>remove_circle</mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
            <tr cbTableRow>
                <td colspan="5" style="text-align: right; border-top: 1px solid #d0d0d0">
                    <button mat-icon-button (click)="openPredecessorDialog()">
                        <mat-icon>add</mat-icon>
                    </button>
                </td>
            </tr>
        </cb-table>
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            class="save-button"
            color="primary"
            [disabled]="!activityForm.valid"
            (click)="saveClicked()"
        >
            Save
        </button>
        <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    </div>
</cb-dialog>
